import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationsService {
    /**
     * Get Notification Types
     * @returns any Successful Response
     * @throws ApiError
     */
    static getNotificationTypesNotificationTypesGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notification/types',
        });
    }
    /**
     * Get Notification Types Chain
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getNotificationTypesChainNotificationTypesChainGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notification/types/{chain}',
            path: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Notification Types Chain
     * @param chain
     * @param notificationType
     * @returns any Successful Response
     * @throws ApiError
     */
    static setNotificationTypesChainNotificationTypesSetChainPost(chain, notificationType) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/types/set/{chain}',
            path: {
                'chain': chain,
            },
            query: {
                'notification_type': notificationType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Notification Types Chain
     * @param chain
     * @param notificationType
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteNotificationTypesChainNotificationTypesDeleteChainDelete(chain, notificationType) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/notification/types/delete/{chain}',
            path: {
                'chain': chain,
            },
            query: {
                'notification_type': notificationType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set User Notification Configs
     * @param userId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setUserNotificationConfigsNotificationConfigSetPost(userId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/config/set',
            query: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Notification Configs
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getUserNotificationConfigsNotificationConfigGetGet(userId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notification/config/get',
            query: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Org User Notification Config
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOrgUserNotificationConfigNotificationConfigGetV2Get(userId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notification/config/get/v2',
            query: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Org User Notification Config
     * @param chains
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrgUserNotificationConfigNotificationExportPost(chains) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/export',
            query: {
                'chains': chains,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All User Notification Configs
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllUserNotificationConfigsNotificationConfigAllGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notification/config/all',
        });
    }
    /**
     * Notify Users
     * @param notificationType
     * @param schedule
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static notifyUsersNotificationNotifyPost(notificationType, schedule, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/notify',
            query: {
                'notification_type': notificationType,
                'schedule': schedule,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Notification Center Types
     * @returns any Successful Response
     * @throws ApiError
     */
    static getNotificationCenterTypesNotificationCenterTypesGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notification/center/types',
        });
    }
    /**
     * Get Notification Center User
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getNotificationCenterUserNotificationCenterGetGet(userId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notification/center/get',
            query: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Notification Center User
     * @param userId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setNotificationCenterUserNotificationCenterSetPost(userId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/center/set',
            query: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sms Config For Chain
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSmsConfigForChainSmsConfigGetGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sms/config/get',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Sms Config For Chain
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setSmsConfigForChainSmsConfigSetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sms/config/set',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Down Reason Types
     * @returns any Successful Response
     * @throws ApiError
     */
    static getStoreDownReasonTypesStoreDownReasonTypesGetGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_down_reason/types/get',
        });
    }
    /**
     * Get Email Config For Chain
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getEmailConfigForChainEmailConfigGetGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/email/config/get',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Email Config For Chain
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setEmailConfigForChainEmailConfigSetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/email/config/set',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
